import {
    BODY_MD_MD_BOLD_STYLES,
    BODY_SM_SM_BOLD_STYLES,
    BODY_SM_SM_MEDIUM_STYLES,
    HEADING_XXXS_STYLES,
} from '@constants/text.ts';
import {
    RATING_SCALE_TABLE_HEADER_CELL_CLASS_NAME,
    RATING_SCALE_TABLE_ID,
} from '@routes/sidebar/admin-center/creator/___pages___/elements/ui/task-element/ui/modals/rating-scale/constants.ts';
import styled from 'styled-components';

export const PrintTaskWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 210mm; // A4 page width; physical units are standard for print layouts
    max-width: 100%;
    min-height: 297mm;
    padding: var(--spacing-md, 24px);
    gap: var(--spacing-md, 24px);
    box-sizing: border-box;
    // standard margins for preview only for A4 print
    margin-top: 2.5cm;
    margin-left: 2.5cm;

    /* Apply print-specific styles only when printing */
    @media print {
        width: 100%;
        max-width: none;
        min-height: auto;
        margin: 0;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    #${RATING_SCALE_TABLE_ID} {
        border: 1px solid var(--colors-border-default, #b4b8bf);
    }
    .${RATING_SCALE_TABLE_HEADER_CELL_CLASS_NAME} {
        font-weight: normal;
    }
`;

export const Header = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_MD_MD_BOLD_STYLES};
`;

export const DataElement = styled.div`
    display: flex;
    gap: 2px;
`;

export const SubHeader = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
`;

export const SubHeaderBold = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_BOLD_STYLES};
`;

export const ScaleHeader = styled.div`
    color: var(--colors-text-headings, #3e445c);
    ${HEADING_XXXS_STYLES};
    margin-bottom: var(--spacing-sm, 16px);
`;

export const TopSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: var(--neutral-150, #f1f4f8);
    margin: -24px -24px 0;
    padding: 24px 0 24px 24px;
`;

export const SubtasksTable = styled.div`
    width: 100%;
    border: 1px solid var(--colors-grey-200, #e2e8f0);
    border-radius: 8px;
    overflow: hidden;
`;

export const SubtasksHeaderRow = styled.div`
    display: grid;
    grid-template-columns: 24% 24% 18% 18% 16%;
    background: var(--colors-grey-150, #f1f4f8);
`;

export const SubtasksRow = styled.div`
    display: grid;
    grid-template-columns: 24% 24% 18% 18% 16%;
    border-top: 1px solid var(--colors-grey-200, #e2e8f0);
`;

export const SubtasksCell = styled.div`
    padding: 8px 12px;
    border-right: 1px solid var(--colors-grey-200, #e2e8f0);
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
    overflow-wrap: anywhere;

    &:last-child {
        border-right: none;
    }
`;

export const SubtasksHeaderCell = styled(SubtasksCell)`
    color: var(--colors-text-headings, #3e445c);
    ${BODY_SM_SM_BOLD_STYLES};
`;

export const GuidelineCell = styled(SubtasksCell)`
    font-style: italic;
`;
